module.exports = __webpack_public_path__ + "static/img/background4.85ee346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background4.png
// module id = 6Tbh
// module chunks = 13